const THEME_TYPES = {
  SELECT: '[theme] select'
}

export default THEME_TYPES
